import { Col, Row } from "antd";
import "./Informationals.scss";
import { stateContents, BodySection, ParagraphItem } from "./stateContent";

interface IProps {
    bodyType: string;
    state: string;
}

const InformationalBodies = (props: IProps) => {
    const { bodyType, state } = props;

    const content = stateContents[state]?.[bodyType as keyof typeof stateContents["UT"]];

    if (!content) {
        return <div></div>;
    }

    return (
        <div className="information-body">
            {content.map((section: BodySection, index: number) => (
                <div className="information-container" key={index}>
                    <Row>
                        <h2>{section.heading}</h2>
                    </Row>
                    <Row style={{ paddingLeft: "1rem" }}>
                        <Col>
                            {section.paragraphs.map((paragraph: string | ParagraphItem, pIndex: number) => (
                                <p key={pIndex}>
                                    {typeof paragraph === "string" 
                                        ? paragraph 
                                        : paragraph.bold 
                                            ? <strong>{paragraph.text}</strong> 
                                            : paragraph.text}
                                </p>
                            ))}
                        </Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default InformationalBodies;
